<template>
    <div class="modal-overlay">
        <div class="modal-content">
            <!-- Title with a lock icon and message -->
            <h3 class="text-2xl font-bold flex items-center space-x-4 text-gray-600">
                <font-awesome-icon :icon="['fas', 'right-left']" class="text-blue-500 mr-2" />
                <span>{{ $translate('We are processing your payment!') }}</span>
            </h3>

            <!-- You can add any additional content below -->
        </div>
    </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
    name: 'ProcessingPaymentModal',
    setup() {
        const router = useRouter();

        const handleReturn = () => {
            router.push('/');
        };

        return {
            handleReturn
        };
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}


.modal-content {
    background-color: #fff;
    padding: 2rem;
    /* Adjusted padding for better spacing */
    border-radius: 0.5rem;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    /* Add slight shadow for depth */
}
</style>